import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Lock } from "lucide-react";

let resolver = null;

export function requestPin() {
  return new Promise((resolve) => {
    resolver = resolve;
    window.dispatchEvent(new Event("fasmart:pin-required"));
  });
}

export function PinGateModal() {
  const [open, setOpen] = useState(false);
  const [pin, setPin] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const h = () => { setPin(""); setOpen(true); };
    window.addEventListener("fasmart:pin-required", h);
    return () => window.removeEventListener("fasmart:pin-required", h);
  }, []);

  const close = (val) => {
    setOpen(false);
    if (resolver) { resolver(val); resolver = null; }
  };

  const submit = async () => {
    if (!pin.trim()) return;
    setBusy(true);
    try {
      await api.post("/admin/verify-pin", { pin: pin.trim() });
      close(pin.trim());
    } catch (e) {
      toast.error(e?.response?.data?.detail || "PIN salah");
    } finally { setBusy(false); }
  };

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[70] bg-black/40 flex items-center justify-center p-4" data-testid="pin-gate-modal">
      <div className="bg-white rounded-2xl w-full max-w-xs p-5 shadow-xl">
        <div className="flex items-center gap-2 mb-1"><Lock className="w-4 h-4 text-emerald-700" /><h3 className="font-display font-black text-base">Verifikasi PIN</h3></div>
        <p className="text-[11px] text-stone-500 mb-3">Menghapus data memerlukan PIN admin.</p>
        <input data-testid="pin-gate-input" type="password" inputMode="numeric" autoFocus value={pin} onChange={(e) => setPin(e.target.value)} onKeyDown={(e) => e.key === "Enter" && submit()} placeholder="Masukkan PIN" className="w-full text-center text-lg font-black tracking-[0.3em] border border-[#E5DECF] rounded-xl px-3 py-2.5 mb-3" />
        <div className="flex gap-2">
          <button data-testid="pin-gate-cancel" onClick={() => close(null)} className="flex-1 py-2 rounded-full border border-[#E5DECF] text-stone-600 text-sm font-bold">Batal</button>
          <button data-testid="pin-gate-confirm" onClick={submit} disabled={busy} className="flex-1 py-2 rounded-full bg-emerald-700 text-white text-sm font-bold disabled:opacity-50">{busy ? "Memeriksa..." : "Konfirmasi"}</button>
        </div>
      </div>
    </div>
  );
}
